export default {
  he: {
    sidenav: {
      dashboard: 'לוח בקרה',
      personalDashboard: 'לוח בקרה אישי',
      orders: 'הזמנה | הזמנות',
      leads: 'ליד | לידים',
      clients: 'לקוח | לקוחות',
      renewals: 'חידוש | חידושים',
      tasks: 'משימה | משימות',
      policies: 'פוליסה | פולסיות',
      departments: 'מחלקה | מחלקות',
      statuses: 'סטטוס | סטטוסים',
      users: 'משתמש | משתמשים',
      messages: 'הודעה | הודעות',
      phoneBook: 'אלפון',
      whatsappCampaign: 'ה.קמפיין וואטסאפ',
      smsCampaign: 'ה.קמפיין SMS',
      mailCampaign: 'ה.קמפיין Mail',
      ordersControl: 'בקרה',
      ordersProtect: 'מיגון',
      ordersCancellations: 'ביטולים',
      ordersCollection: 'גבייה',
      ordersTasks: 'משימות',
      ordersClaims: 'תביעות',
      calculator: 'מחשבון דירה',
      // collaborations: 'שת"פ',
      // ordersHistory: 'היסטורית הזמנות',
      // logs: 'לוגים',
    },
    message: {
      FilterByColumn: 'סינון לפי עמודה',
      MoreOptions: 'אפשרויות נוספות',
      Username: 'שם משתמש',
      Email: 'אימייל',
      Phone: 'טלפון',
      SystemLanguage: 'שפת מערכת',
      Hebrew: 'עברית',
      Engliish: 'אנגלית',
      Avatar: 'תמונת פרופיל',
      Browse: 'עיון',
      ChooseFile: 'בחר',
      CurrentPassword: 'סיסמה נוכחית',
      NewPassword: 'סיסמה חדשה',
      RepeatNewPassword: 'סיסמה חדשה שוב',
      MySettings: 'ההגדרות שלי',
      ChangePassword: 'שינוי סיסמה',
      NewRow: 'הוספת שורה חדשה',
      goBack: 'חזור אחורה',
      tableNotFound: 'טבלה לא נמצאה / לא קיימת',
      dateFilter: 'סנן לפי תאריך',
      close: 'סגור',
      clean: 'נקה',
      logout: 'התנתק',
      openNewOrder: 'פתח הזמנה חדשה',
      cleanFilter: 'נקה פילטרים',
      products: 'מוצרים',
      customers: 'לקוחות',
      renewals: 'חידושים',
      ok: 'אישור',
      cancel: 'ביטול',
      update: 'עדכון',
    },
    months: {
      January: 'ינואר',
      February: 'פבואר',
      March: 'מרץ',
      April: 'אפריל',
      May: 'מאי',
      June: 'אפריל',
      July: 'יולי',
      August: 'אוגוסט',
      September: 'ספטמבר',
      October: 'אוקטובר',
      November: 'נובמבר',
      December: 'דצמבר',
    },
    dashboard: {
      leads: 'לידים חדשים',
      personalDashboard: 'לוח בקרה אישי',
      orders: 'הזמנות חדשות',
      tasks: 'משימות חדשות',
      service: 'לידים שירות חדשים',
      totalProducts: 'סהכ מוצרים',
      totalIncome: 'סהכ הכנסה',
      revenueCurrentMonth: 'הכנסות לפי מוצר נטו החודש',
      productsCurrentMonth: 'מוצרים שנמכרו החודש',
      ordersLast2Monthes: 'הזמנות חודשיים אחרונים',
      renewals: 'חידושים',
      newCustomers: 'לקוחות חדשים החודש',
      currentMonth: 'חודש נוכחי',
      lastMonth: 'חודש קודם'
    },
    tables: {
      general: {
        display: 'מציג',
        to: 'עד',
        of: 'מתוך',
        searchQuery: 'ביטוי לחיפוש',
        records: 'רשומות',
        oneRecord: 'רשומה 1',
        page: 'עמוד',
        noMatchingRecords: 'לא נמצאו רשומות',
        filterBy: 'סנן לפי',
        loading: 'טוען...',
        select: 'בחר',
        columns: 'עמודות',
      },
      headers: {
        id: 'מספר',
        fullName: 'שם מלא',
        leadType: 'סוג הליד',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל',
        billingDate: 'תאריך חיוב',
        mobilePhone: 'נייד',
        departments: 'מחלקות',
        type: 'סוג',
        subject: 'נושא',
        name: 'שם',
        tz: 'ת"ז',
        paymentKind: 'א.ת',
        phone: 'טלפון',
        content: 'תוכן המייל',
        leadKind: 'סוג ליד',
        source: 'מקור',
        followUp: 'מעקב',
        status: 'סטטוס',
        extra: 'מידע נוסף',
        department: 'מחלקה',
        department_id: 'מזהה מחלקה',
        departmentId: 'מזהה מחלקה',
        agencyId: 'מזהה סוכנות (id)',
        isShowStatus: 'להציג סטטוס',
        //departmentAllowedToMassage: 'מחלקה מורשית הודעה',
        modelAllowedToMassage: 'הודעות לפי מודל',
        color: 'צבע',
        order: 'מספר סידורי',
        isDefault: 'ברירת מחדל',
        userName: 'יוצר',
        model: 'מודל',
        company: 'חברה',
        premium: 'פרימיום',
        productType: 'סוג מוצר',
        branchNumber: 'מספר ענף',
        manufactureYear: 'תאריך רישוי',
        messageRenew: 'הודעת חידוש',
        comments: 'הערות',
        actions: 'פעולות',
        password: 'סיסמה',
        description: 'תיאור',
        customerName: 'שם לקוח',
        carNumber: 'מס רכב',
        employeeName: 'שם עובד',
        builtYear: 'שנת ייצור',
        statusId: 'סטטוס',
        statusName: 'סטטוס',
        ins_order: 'מספר הזמנה',
        linkedOrder: 'קישור להזמנה',
        'insurance-date-start': 'ת.תחילה',
        'insurance-date-finish': 'תאריך סיום ביטוח',
        'ins-type': 'סוג ביטוח',
        'customerExists': 'לקוח קיים',
        'newCustomer': 'לקוח חדש',
        isRenew: 'דרוש חידוש',
        levelOfProtection: 'רמת מיגון',
        protectionStatus: 'מצב מיגון',
        //statusHistoryInsurance: 'סטטוס היסטוריית ביטוחים',
        'license-number': 'מספר רכב',
        'levi-code': 'קוד לוי',
        'vehicle-manufacturer': 'יצרן',
        'vehicle-brand': 'דגם',
        'vehicle-year': 'שנה',
        'vehicle-sub-brand': 'תת דגם',
        secondType: 'מצב משני',
        engine_capacity: 'נפח מנוע',
        gearBox: 'תיבת הילוכים',
        ownership: 'בעלות',
        esp: 'בקרת יציבות',
        fcw: 'מזה fcw',
        ldw: 'LDW מזה',
        'license-number-go': 'מספר רכב להצעת מחיר',
        //M1N1: 'M1N1 מזה',
        'keeping-distance-system': 'מערכת שמירת מרחק',
        'deviation-system': 'מערכת סטייה',
        'insurance_protection_text': 'מערכת מיגון',
        'vehicle_search_method': 'דגם משרד התחבורה',
        'mortgaged': 'רכב משועבד',
        'ownership-date': 'מועד בעלות',
        'ownership-under-year': 'בעלות מתחת לחודש',
        'insurance-before': 'האם היה ביטוח קודם?',
        'insurance-1-year': ' שנה ראשונה',
        'insurance-2-year': ' שנה שנייה',
        'insurance-3-year': ' שנה שלישית',
        'law-suites-3-year': 'תביעות ב-3 שנים האחרונות',
        'law-suite-what-year': 'שנת התביעה',
        'criminal-record': 'עבר פלילי',
        tac: 'תקנון',
        'body-claims': 'תביעות גוף',
        age: 'גיל',
        'lowest-seniority': 'וותק נהיגה',
        'drive-allowed-number': 'רשאים לנהוג',
        'youngest-driver': 'הנהג הצעיר ביותר',
        'drive-on-saturday': 'נוסע בשבת',
        'license-suspensions': 'שלילות רישיון',
        'first-name': 'שם פרטי',
        'last-name': 'שם משפחה',
        'identical-number': 'תעודת זהות',
        gender: 'מין',
        'drive-allowed': 'כשיר לנהיגה',
        'license-year': 'שנת הוצאת רישיון',
        'mobile-phone-number': 'נייד',
        'additional-phone-number': 'טלפון נוסף',
        city: 'עיר',
        street: 'רחוב',
        policeOwnerGender: 'מין',
        'house-number': 'מספר בית',
        'apartment-number': 'מספר דירה',
        'use-another-address': 'כתובת - אחר',
        'city-another': 'עיר - אחר',
        'street-another': 'רחוב - אחר',
        'house-number-another': 'מספר בית - אחר',
        'apartment-number-another': 'מספר דירה - אחר',
        firstDriverFirstName: 'נהג ראשון',
        firstDriverLastName: 'נהג ראשון',
        firstDriverTz: 'ת"ז',
        firstDriverYearBirth: 'שנת לידה',
        firstDriverGender: 'מין',
        firstDriverLicenceYear: 'שנת הוצאת רישיון',
        secondDriverFirstName: 'שם פרטי נהג שני',
        secondDriverLastName: 'שם פרטי נהג שני',
        secondDriverTz: 'ת"ז נהג שני',
        secondDriverYearBirth: 'שנת לידה נהג שני',
        secondDriverGender: 'מין נהג שני',
        secondDriverLicenceYear: 'שנת הוצאת רישיון נהג שני',
        thirdDriverFirstName: 'שם פרטי נהג שלישי',
        thirdDriverLastName: 'שם פרטי נהג שלישי',
        thirdDriverTz: 'ת"ז נהג שלישי',
        thirdDriverYearBirth: 'שנת לידה נהג שלישי',
        thirdDriverGender: 'מין נהג שלישי',
        thirdDriverLicenceYear: 'שנת הוצאת רישיון נהג שלישי',
        priceType: 'סוג מחיר',
        hovaCompany: 'חובה',
        secondCompany: 'רכוש',
        hovaNumberOfPays: 'מספר תשלומים',
        hovaStartInsurance: 'תחילת ביטוח חובה',
        hovaEndInsurance: 'סיום ביטוח חובה',
        'thirdPartyPrice/comprehensivePrice': 'מחיר צד שלישי',
        'thirdPartyCompany/comprehensiveCompany': 'חברת צד שלישי',
        comprehensiveTaxPay: 'תשלום מיסים',
        propertyInsuranceStart: 'רכוש - תחילת ביטוח',
        propertyInsuranceEnd: 'רכוש - סיום ביטוח',
        'propertyPolicyNumber': 'רכוש - מספר פולסיה',
        policyNumber: 'פוליסה',
        deductible: 'ה.עצמית',
        debtSettlement: 'ה.ע בהסדר',
        zadGimelRes: 'גבול אחריות',
        custom: 'מותאם אישית',
        packagePrice: 'חבילת מחיר',
        packageName: 'שם החבילה',
        packageInsuranceStart: 'תכולה - תחילת הביטוח',
        packageInsuranceEnd: 'תכולה - סיום הביטוח',
        packageNumber: 'מספר תכולה',
        expansionName: 'שם הרחבה',
        expansionDescription: 'תיאור הרחבה',
        expansionPrice: 'מחיר הרחבה',
        expansionNumber: 'מספר הרחבה',
        expansionInsuranceStart: 'הרחבה - תחילת הביטוח',
        expansionInsuranceEnd: 'הרחבה - סיום הביטוח',
        cardHolderName: 'שם בעל כרטיס האשראי',
        cardHolderTz: 'ת"ז בעל כרטיס האשראי',
        cardNumber: 'מספר אשראי',
        cardMonth: 'חודש אשראי',
        cardYear: 'שנה אשראי',
        cardHolderPhoneNumber: 'טלפון בעל כרטיס האשראי',
        deleteCredit: 'קרדיט מחוק?',
        'policy-send': 'פוליסה נשלחה',
        userIp: 'USER IP',
        surfingSource: 'מקור הגעה',
        fromSrc: 'טופס הגעה',
        userAgent: 'דפדפן',
        ins_link: 'קישור INS',
        baseOn: 'מבוסס על',
        revision: 'סטטוס אבא',
        'ins-order': 'מספר הזמנה',
        'birthday-date': 'תאריך לידה',
        'tac-1': 'תקנון',
        'customerId': 'מספר לקוח',
        'displayName': 'שם תצוגה',
        'smsPhoneNumber': 'SMS מספר נייד',
        'address': 'נמען',
        'replayTo': 'למי להשיב',
        'isSms': 'האם SMS',
        'isWhatsapp': 'האם וואטסאפ',
        'isEmail': 'האם מייל',
        'whatsappContent': 'תוכן וואטסאפ',
        'whatsappTemplateName': 'שם תבנית וואטסאפ',
        'smsContent': 'תוכן SMS',
        'isEditable': 'לא ניתן לעריכה',
        'isEditFile': 'חייב צירוף קבצים',
        'classAllowedToMassage': 'מחלקה שמורשת להודעה',
        'autoSend': 'שליחה אוטומטית/ידנית',
        dateStart: 'תאריך תחילה',
        insuranceType: 'סוג ביטוח',
        insurancePolicy: 'פוליסת ביטוח',
        branch: 'ענף',
        codeType: 'סוג קוד',
        carName: 'שם רכב',
        carType: 'סוג רכב',
        engineCapacity: 'נפח מנוע',
        orderId: 'מס הזמנה',
        productName: 'מוצר',
        companyName: 'חברה',
        hovaCompanyName: 'ביטוח חובה',
        makifCompanyName: 'ביטוח מקיף',
        zadGimelCompanyName: 'צד ג',
        startDate: 'התחלה',
        endDate: 'סיום',
        price: 'מחיר',
        numberOfPayment: 'תשלומים',
        note: 'הערה',
        costPerMount: 'מחיר לחודש',
        productFile: 'קובץ מצורף',
        dateFileDelivery: 'תארי שליחת קובץ',
        productStatus: 'סטטוס מוצר',
        updated_at: 'התעדכן ב',
        statusGroup: 'קבוצת סטטוסים',
        isAllowPaymentCompletion: 'לאפשר השלמת תשלום',
        insuranceCompany: 'חברת הביטוח',
        'add-info': 'הוסף מידע',
        event: 'אירוע',
        dateEnd: 'תאריך סיום',
        subBranch: 'תת ענף',
        lackOfClaimsStatus: 'סטטוס עבר ביטוחי',
        protectiveStatus: 'סטטוס מיגון',
        activeOrderId: 'מזהה הזמנה פעילה',
        created_at: 'נוצר ב',
        isShowMessage: 'האם להציג הודעה',
        updatedByUserName: 'עודכן על ידי',
        updatedByUser_at: 'עודכן בתאריך',
        orderSource: 'מקור ההזמנה',
        createdFrom: 'נוצר מ',
        client_phone: 'נייד לקוח',
        license_number: 'מספר רישוי',
        insurance_select_period: 'תחילת ביטוח',
        messageKind: 'סוג הודעה',
        campaign_id: 'קמפיין',
        policyStatus: 'סטטוס ביטולים',
        paymentStatus: 'סטטוס גבייה',
        changesStatus: 'סטטוס שינויים',
        claimsStatus: 'סטטוס תביעות',
        birthDate: 'יום הולדת',
        stepsInfo: 'מידע של השלבים',
        isRenewalOfExistingInsurance: 'חדש/חידוש',
        modeSource: 'תצוגת CRM',
        dashboard_groups: 'קבוצות דשבורד',
        dashboard_statuses: 'סטטוסים בדשבורד',
        group_id: 'קבוצות דשבורד',
      },
    },
    orders: {
      main: 'מידע ראשי',
      'last-name': 'שם משפחה',
      lastUpdate: 'עדכון אחרון',
      updateBy: 'עודכן על ידי',
      status: 'סטטוס',
      billingDate: 'תאריך חיוב',
      orderSource: 'מקור ההזמנה',
      type: 'סוג ביטוח',
      period: 'תק ביטוח',
      insNum: 'מס הזמנה',
      source: 'יוצר',
      driveInCar: 'נוהג ברכב',
      notDriveInCar: 'לא נוהג ברכב',
      to: 'עד',
      carNum: 'מס רכב',
      insuranceHistory: 'עבר ביטוחי',
      policyOwner: 'בעל הפוליסה',
      driverAltAddress: 'כתובת למשלוח דואר שונה',
      city: 'עיר',
      street: 'רחוב',
      houseNum: 'מס בית',
      aptNum: 'מס דירה',
      files: 'קבצים',
      notes: 'הערות',
      ongoingTreatment: 'טיפול שוטף',
      save: 'שמור',
      subject: 'נושא',
      secondMailAddress: 'כתובת מייל נוספת',
      description: 'תיאור',
      time: 'זמן',
      by: 'ע"י',
      driver: 'בעל הפוליסה',
      dragFiles: 'גרור קבצים',
      update: 'עדכן',
      drivers: 'נהגים נוספים',
      addNewNote: 'הוסף הערה חדשה',
      updateStatus: 'שינוי סטטוס',
      historyInsurance: 'עבר ביטוחי',
      protective: 'מיגון',
      addNewProduct: 'הוסף מוצר חדש',
      editCompareDetails: 'השוואה חדשה',
      editPolicyInfo: 'סיים הזמנה באתר',
      lackOfClaims: 'סטטוס העדר תביעות',
      paymentStatus: 'גביה',
      policyStatus: 'פוליסה',
      claimsStatus: 'תביעות',
      changesStatus: 'שינויים',
      protectiveStatus: 'מיגון',
      editOrder: 'עדכון הזמנה',
      products: 'מוצרים',
      cardHolderInfo: 'פרטי בעל הכרטיס',
      cardHolderName: 'שם בעל הכרטיס',
      cardHolderPhone: 'טלפון המשלם',
      cardNumber: 'מספר כרטיס',
      cardHolderMonth: 'תוקף חודש',
      cardHolderYear: 'תוקף שנה',
      policyConditions: 'תנאי ביטוח',
      yes: 'כן',
      no: 'לא',
      hova: 'חובה',
      mekif: 'מקיף',
      zadGimel: 'צד ג',
      noInsurance: 'לא היה',
      commercial: 'חברה',
      private: 'פרטי',
      male: 'זכר',
      female: 'נקבה',
      fileName: 'שם קובץ',
      view: 'צפייה',
      general: 'כללי',
      production: 'הפקה',
      payment: 'תשלום',
      noTitle: 'ללא כותרת',
      noDescription: 'ללא תיאור',
      title: 'כותרת',
      actions: 'פעולות',
      statuses: 'סטטוסים',
      drafts: 'טיוטות',
      overAYear: 'מעל חודש',
      underAYear: 'מתחת לחודש',
      autoSend: 'נשלח אוטומטית',
      clonePolicy: 'שכפול פוליסה',
      messages: 'הודעות',
      newMsg: 'הודעה חדשה',
      address: 'כתובת',
      body: 'גוף ההודעה',
      msgFiles: 'קבצים לשליחה',
      selectFiles: 'בחר/י קובץ',
      selectContact: 'בחר/י איש קשר',
      select: 'בחר/י',
      msgType: 'סוג ההודעה',
      remove: 'מחיקה',
      submit: 'שלח',
      content: 'תוכן',
      smsContent: 'תוכן SMS',
      download: 'הורד',
      moreInfo: 'מידע נוסף',
      clickToEdit: '(לחץ כדי לערוך)',
      addressNotSelected: 'במידה ולא נבחר איש קשר, ההודעה תשלח לבעל הפוליסה',
      selectDepartments: 'בחר/י מחלקות',
      created_at: 'נוצר ב',
      created_from: 'נוצרה מ',
      browseThroughOrders: 'דפדף בין הזמנות',
      cleanOrderChoose: 'נקה הזמנות נבחרות',
      'birthday-date': 'תאריך לידה',
      showCreditDetails: 'הצג כרטיס אשראי',
      creditNumber: 'מספר כרטיס:',
      expirationDate: 'תוקף:'
    }
  }
}
